import { FieldErrors } from "react-hook-form"
import Alert from "~/components/ui/Alert"
import Button from "~/components/ui/Button"
import Spinner from "~/components/ui/Spinner"

type Props = {
  isDirty: boolean
  isLoading?: boolean
  errors: FieldErrors<Record<any, any>>
  handleCancel?: () => void
}

export default function SaveButtons({ isDirty, isLoading, handleCancel, errors }: Props) {
  const errorMessages = Object.values(errors).flatMap((error) => {
    if (error && error.message) {
      return typeof error.message === "string" ? error.message : String(error.message)
    }
    return []
  })

  const combinedErrorMessage = errorMessages.join(", ")

  return (
    <div className="flex flex-col gap-2">
      <div className="flex w-full items-center">
        {isDirty && <p className="text-gray-400">There are some changes that should be saved</p>}
        <Button disabled={!isDirty || isLoading} className="mr-4 ml-auto" onClick={handleCancel}>
          Cancel
        </Button>
        <Button disabled={!isDirty || isLoading} variant="green" type="submit">
          {isLoading ? <Spinner size={4} /> : "Save"}
        </Button>
      </div>
      {combinedErrorMessage && <Alert description={combinedErrorMessage} />}
    </div>
  )
}
